import React from 'react';
import './qualifications.css'

import ico from '../props/quil-code-ico.png'
import ico1 from '../props/tools-ico.png'
import ico2 from '../props/bulb-ico.png'
import ico3 from '../props/thunder ico.png'

import img1 from '../props/html Qualification1.png'
import img2 from '../props/CSS Qualification.png'
import img3 from '../props/js Qualification2.png'
import img4 from '../props/react Qualification.png'
import img5 from '../props/Bootstrap Qualification.png'
import img6 from '../props/tailwind Qualification.png'
import img7 from '../props/php Qualification.png'
import img8 from '../props/laravel-Qualification1.png'
import img9 from '../props/mongodb Qualification.png'
import img10 from '../props/wordpress Qualification.png'
import img11 from '../props/postman Qualification.png'
import img12 from '../props/git Qualification.png'
import img13 from '../props/github Qualification.png'
import img14 from '../props/Microsoft Qualification.png'
import img15 from '../props/node-js Qualification.png'

const Qualifications = () => {

  return (
    <>
    <div id="qualifications" className="qualifications-container">
          <h1 className="quali-text">My Qualification</h1>
          <span className="quali-text-two"><img
                      src={ico}
                      alt="code"
                      style={{
                        width: '60px',
                        height: '60px',
                      }}
                      ></img>Front End Languages :</span>
          <div className='qualification'>
              <div className="card rotate">
                <div className="image">
                  <img src={img1} alt="" />
                </div>
                <div className="description">HTML</div>
              </div>

              <div className="card rotate">
                <div className="image">
                  <img src={img2}  alt="" />
                </div>
                <div className="description">CSS</div>
              </div>

              <div className="card rotate" >
                <div className="image">
                  <img src={img3}  alt="" />
                </div>
                <div className="description">JavaScript</div>
              </div>
          </div>

          <span className="quali-text-two"><img
                      src={ico2}
                      alt="code"
                      style={{
                        width: '60px',
                        height: '60px',
                      }}
                      ></img>Front-End Frameworks and Libraries :</span>
          <div className='qualification'>
              <div className="card rotate">
                <div className="image">
                  <img src={img4} alt="" />
                </div>
                <div className="description">React.js</div>
              </div>

              <div className="card rotate">
                <div className="image">
                  <img src={img5}  alt="" />
                </div>
                <div className="description">Bootstrap</div>
              </div>

              <div className="card rotate" >
                <div className="image">
                  <img src={img6}  alt="" />
                </div>
                <div className="description">Tailwind</div>
              </div>
          </div>

          <span className="quali-text-two"><img
                      src={ico3}
                      alt="code"
                      style={{
                        width: '60px',
                        height: '60px',
                      }}
                      ></img>Back End Languages and Frameworks :</span>
          <div className='qualification'>
              <div className="card rotate">
                <div className="image">
                  <img src={img7} alt="" />
                </div>
                <div className="description">PHP</div>
              </div>

              <div className="card rotate">
                <div className="image">
                  <img src={img8}  alt="" />
                </div>
                <div className="description">Laravel</div>
              </div>

              <div className="card rotate" >
                <div className="image">
                  <img src={img9}  alt="" />
                </div>
                <div className="description">MongoDB</div>
              </div>
          </div>

          <span className="quali-text-two"><img
                      src={ico1}
                      alt="code"
                      style={{
                        width: '60px',
                        height: '60px',
                      }}
                      ></img>Full Featured and Tools:</span>
          <div className='qualification'>
              <div className="card rotate">
                <div className="image">
                  <img src={img10} alt="" />
                </div>
                <div className="description">WordPress</div>
              </div>

              <div className="card rotate">
                <div className="image">
                  <img src={img11}  alt="" />
                </div>
                <div className="description">Postman</div>
              </div>

              <div className="card rotate" >
                <div className="image">
                  <img src={img12}  alt="" />
                </div>
                <div className="description">Git</div>
              </div>
              <div className="card rotate">
                <div className="image">
                  <img src={img13} alt="" />
                </div>
                <div className="description">GitHub</div>
              </div>

              <div className="card rotate">
                <div className="image">
                  <img src={img14}  alt="" />
                </div>
                <div className="description">Microsoft</div>
              </div>

              <div className="card rotate" >
                <div className="image">
                  <img src={img15}  alt="" />
                </div>
                <div className="description">Node.js</div>
              </div>



          </div>






    </div>
    </>
  );
};

export default Qualifications;
